export default __webpack_public_path__ + "assets/images/96237d308ac42f69e9cd13459d8441ba.png";